import React from 'react';

const Notification: React.VFC = () => (
  <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5 29.0833C14.1041 29.0833 15.4166 27.7708 15.4166 26.1666H9.58331C9.58331 27.7708 10.8958 29.0833 12.5 29.0833ZM21.25 20.3333V13.0416C21.25 8.5645 18.8729 4.81659 14.6875 3.82492V2.83325C14.6875 1.62284 13.7104 0.645752 12.5 0.645752C11.2896 0.645752 10.3125 1.62284 10.3125 2.83325V3.82492C6.14165 4.81659 3.74998 8.54992 3.74998 13.0416V20.3333L0.833313 23.2499V24.7083H24.1666V23.2499L21.25 20.3333ZM18.3333 21.7916H6.66665V13.0416C6.66665 9.42492 8.86873 6.47909 12.5 6.47909C16.1312 6.47909 18.3333 9.42492 18.3333 13.0416V21.7916Z" fill="#333333" />
  </svg>
);

export default Notification;
